import { useState, useEffect } from "react";
import moment from "moment";
import { GetAppliedHistory } from "$ACTIONS/cmsApi";
import { bonusStatusMapping } from "$ACTIONS/promotionRequest";

/**
 * 自定義 Hook: 用於獲取 AppliedHistory 數據
 * @param {string} myPromotionSubtab - 當前的 promotion 類型 ("inProgress", "claimable", "completed")
 * @param {boolean} hasDatePicker - 是否需要 DatePicker (如果 false，則預設最近 90 天)
 */
const useFetchAppliedHistory = (myPromotionSubtab, hasDatePicker = false) => {
    const [loading, setLoading] = useState(false);
    const [promotions, setPromotions] = useState([]);

    const [dateRange, setDateRange] = useState(
        hasDatePicker
            ? { from: moment().startOf("month"), to: moment().endOf("month") }
            : { from: moment().utcOffset(8).subtract(90, "days").startOf("day"), to: moment().utcOffset(8) }
    );

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = {
                startDate: dateRange.from.format("YYYY-MM-DDTHH:mm:ss"),
                endDate: dateRange.to.format("YYYY-MM-DDTHH:mm:ss"),
                bonusStatusArray: bonusStatusMapping[myPromotionSubtab],
            };

            const res = await GetAppliedHistory(params);
            setPromotions(res && Array.isArray(res) ? res : []);
        } catch (error) {
            console.error("Error fetching data:", error);
            setPromotions([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [dateRange]); // 日期範圍變更時自動觸發 API

    return { promotions, loading, dateRange, setDateRange };
};

export default useFetchAppliedHistory;
